module.exports = __webpack_public_path__ + "img/60.035e1854.svg";